import React, { useState, useEffect } from 'react';
import '../../style/dashboard.css'; // Assuming you'll create some styles for the dashboard
import api from '../../redux/actions/configApi';

const Dashboard = () => {
    // For now, we'll use mock data. In a real application, you'd fetch this from an API.
    const [proposalStats, setProposalStats] = useState({
        total: 0,
        statuses: {}
    });

    const [orderStats, setOrderStats] = useState({
        total: 0,
        statuses: {}
    });

    const getTextoTabela = (statusValue) => {
        switch (Number(statusValue)) {
            case 4: return 'Código enviado';
            case 5: return 'Em trânsito';
            case 6: return 'Venda aprovada';
            case 7: return 'Venda reprovada';
            case 8: return 'Contraproposta enviada';
            case 9: return 'Contraproposta aprovada';
            case 10: return 'Produto devolvido';
            case 11: return 'Venda cancelada';
            default: return 'Aguardando';
        }
    };

    const getTextoTabelaOrder = (statusValue) => {
        switch (Number(statusValue)) {
            case 1: return 'Pendente';
            case 2: return 'Aprovado';
            case 3: return 'Cancelado';
            case 4: return 'Retirada';
            case 5: return 'Entregue';
            default: return 'Aguardando';
        }
    };

    useEffect(() => {
        const fetchStats = async () => {
            try {
                const response = await api.get('/dasboardUser');
                console.log(response.data, 'response.data')
                setProposalStats(response.data);
            } catch (error) {
                console.error('Erro ao buscar estatísticas:', error);
            }
        };

        const fetchStatsOrder = async () => {
            try {
                const response = await api.get('/dasboardOrderUser');
                setOrderStats(response.data);
            } catch (error) {
                console.error('Erro ao buscar estatísticas:', error);
            }
        };

        fetchStats();
        fetchStatsOrder();
    }, []);
    // Processamento dos dados
    const statusMap = {};
    let aguardandoTotal = 0;

    for (const [status, count] of Object.entries(proposalStats.statuses)) {
        const label = getTextoTabela(status);
        if (label) {
            statusMap[label] = (statusMap[label] || 0) + count;
        } else {
            aguardandoTotal += count;
        }
    }

    if (aguardandoTotal > 0) {
        statusMap['Aguardando'] = aguardandoTotal;
    }
    /***********************Order */
    const statusMapOrder = {};
    let aguardandoTotalOrder = 0;

    for (const [status, count] of Object.entries(orderStats.statuses)) {
        const label = getTextoTabelaOrder(status);
        if (label) {
            statusMapOrder[label] = (statusMapOrder[label] || 0) + count;
        } else {
            aguardandoTotalOrder += count;
        }
    }

    if (aguardandoTotalOrder > 0) {
        statusMap['Aguardando'] = aguardandoTotalOrder;
    }
    return (
        <div className="dashboard">
            <h2 className="text-center mb-4 titulo-modal titulo-pagina"><i style={{ color: '#ff7a00' }} class="fa-solid fa-chart-pie mr-3"></i>  Dashboard</h2>
            <div className="dashboard-cards">
                <div className="card">
                    <h2><i class="fas fa-shopping-cart"></i> Pedidos de Compra</h2>
                    {Object.entries(statusMap).map(([label, count]) => (
                        <p key={label}>
                            {label}: <strong>{count}</strong>
                        </p>
                    ))}
                    <p>Total: <strong>{proposalStats.total}</strong></p>
                </div>

                <div className="card">
                    <h2><i class="fas fa-file-invoice"></i> Pedidos de Venda</h2>
                    {Object.entries(statusMapOrder).map(([label, count]) => (
                        <p key={label} style={{ margin: '0px' }}>
                            {label}: <strong>{count}</strong>
                        </p>
                    ))}
                    <p>Total: <strong>{orderStats.total}</strong></p>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;